// noinspection GraphQLUnresolvedReference

import { gql, GraphQLClient } from 'graphql-request'

import { AccessToken } from '../../../base/models/paramsModel'
import { MyGraphQlError } from '../../../base/services/GraphqlError'
import { PAGE_DEFAULT, PageInfoProps, PageInputProps } from '../../../interfaces'
import { ArticuloProps } from '../../../interfaces/articulo.ts'

/**
 * Respuesta de productos
 */
interface ApiArticulosResponse {
  docs: ArticuloProps[]
  pageInfo: PageInfoProps
}

const query = gql`
  query LISTADO($cds: Int!, $limit: Int!, $reverse: Boolean, $page: Int!, $query: String) {
    articuloListado(cds: $cds, limit: $limit, reverse: $reverse, page: $page, query: $query) {
      docs {
        _id
        codigoArticulo
        nombreArticulo
        descripcionArticulo
        sinProductoServicio {
          codigoActividad
          codigoProducto
          descripcionProducto
        }
        actividadEconomica {
          codigoCaeb
          descripcion
          tipoActividad
        }
        tipoArticulo {
          _id
          codigo
        }
        proveedor {
          _id
          codigo
          nombre
        }
        claseArticulo
        gestionArticulo
        tipoUnidadMedida
        codigoUnidadRef
        verificarStock
        articuloVenta
        articuloCompra
        articuloProduccion
        activo
        state
        usucre
        usumod
        createdAt
        updatedAt
      }
      pageInfo {
        hasNextPage
        hasPrevPage
        totalDocs
        limit
        page
        totalPages
      }
    }
  }
`

/**
 * Exportamos los articulos, se realiza la busqueda de 10000 articulos
 * @param limit
 */
export const apiArticuloExportar = async (limit: number): Promise<ApiArticulosResponse> => {
  try {
    const client = new GraphQLClient(import.meta.env.ISI_API_URL)
    const token = localStorage.getItem(AccessToken)
    // Set a single header
    client.setHeader('authorization', `Bearer ${token}`)
    const pageInfo: PageInputProps = { ...PAGE_DEFAULT, limit }

    const data: any = await client.request(query, { ...pageInfo, cds: 1 })
    return data.articuloListado
  } catch (e: any) {
    throw new MyGraphQlError(e)
  }
}
